import { c as _c } from "react/compiler-runtime";
import type { LpCardListItem } from '@cc-shopping/contracts/credit-cards-page/landing-page/CreditCardsLPCardList';
import { Box, Typography } from '@mui/material';
import { Accordion } from './components/Accordion';
import { Divider } from './Divider';
export function OtherPerks(t0) {
  const $ = _c(12);
  const {
    title,
    items
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      flexDirection: {
        xs: "column",
        md: "row"
      },
      gap: {
        xs: "1.5rem",
        md: 2
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = title && <Typography component="h2" sx={{
      alignSelf: {
        md: "center"
      },
      fontSize: 24,
      fontWeight: 700
    }}>{title}</Typography>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Divider />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      display: "flex",
      flexDirection: "column",
      gap: 3,
      flex: 1,
      listStyle: "none",
      padding: 0,
      margin: 0
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== items) {
    t5 = items.map(_temp);
    $[5] = items;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5) {
    t6 = <Box component="ul" sx={t4}>{t5}</Box>;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t6) {
    t7 = <Box sx={t1}>{t2}{t3}{t6}</Box>;
    $[9] = t2;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
function _temp(item) {
  return <Accordion key={item.title} item={item} />;
}